/* 手机号 */
export function validPhone (str) {
  const reg = /^1[345678]\d{9}$/
  return reg.test(str)
}
